// extracted by mini-css-extract-plugin
export default {"link":"DesktopHeader_link__uguvz","hiddenMobile":"DesktopHeader_hiddenMobile__wO7Bu","hiddenDesktop":"DesktopHeader_hiddenDesktop__0nG2J"};